import "mutationobserver-shim";
import Vue from "vue";
import "./bootstrap-vue";
import { ModalPlugin } from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import i18n from "./i18n";

Vue.config.productionTip = false;
Vue.use(ModalPlugin);

export const bus = new Vue();

Vue.directive("focus", {
    inserted: function (el) {
        el.focus();
    }
});
store.dispatch("authentication/validateToken");

new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount("#app");
